import Swal from 'sweetalert2';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    showSuccess(message: string, title: string = 'Sucesso!') {
        Swal.fire({
            title: title,
            text: message,
            icon: 'success',
            confirmButtonText: 'OK',
        });
    }

    showError(message: string, title: string = 'Erro!') {
        Swal.fire({
            title: title,
            html: message,
            icon: 'error',
            confirmButtonText: 'OK',
        });
    }

    showWarning(message: string, title: string = 'Atenção!') {
        Swal.fire({
            title: title,
            html: message,
            icon: 'warning',
            confirmButtonText: 'OK',
        });
    }

    showInfo(message: string, title: string = 'Informação!') {
        Swal.fire({
            title: title,
            html: message,
            icon: 'info',
            confirmButtonText: 'OK',
        });
    }

    showToast(message: string, icon: any = 'success') {
        Swal.mixin({
            toast: true,
            position: 'top-end',
            timer: 2500,
            timerProgressBar: true,
            showConfirmButton: false,
        }).fire({ icon, title: message });
    }

    /**
     * Confirmação que exige uma justificativa escrita.
     *
     * Usada em operações que mexem no saldo de terceiros — cancelar uma
     * compra, estornar um lançamento. A justificativa vai para o registro e
     * é o que permite entender depois por que aquilo foi feito.
     *
     * Devolve o texto informado, ou `null` se a pessoa desistir.
     */
    async confirmWithReason(
        titulo: string,
        html: string,
        placeholder = 'Descreva o motivo',
    ): Promise<string | null> {
        const resultado = await Swal.fire({
            title: titulo,
            html,
            icon: 'warning',
            input: 'textarea',
            inputPlaceholder: placeholder,
            inputAttributes: { 'aria-label': placeholder },
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Voltar',
            confirmButtonColor: '#560000',
            cancelButtonColor: '#6b7280',
            inputValidator: (valor) =>
                !valor || valor.trim().length < 5
                    ? 'Descreva o motivo com pelo menos 5 caracteres.'
                    : null,
        });

        return resultado.isConfirmed ? String(resultado.value).trim() : null;
    }

    /**
     * Confirmação simples, em promessa.
     *
     * O `confirmMessage` antigo devolve por callback e usa o azul de outro
     * produto; este segue a paleta da casa e dá para aguardar.
     */
    async confirm(titulo: string, html: string): Promise<boolean> {
        const resultado = await Swal.fire({
            title: titulo,
            html,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Voltar',
            confirmButtonColor: '#560000',
            cancelButtonColor: '#6b7280',
        });

        return resultado.isConfirmed === true;
    }

    confirmMessage(t: string, m: string, callback: any = null) {
        Swal.fire({
            title: t,
            html: m,
            icon: 'warning',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            confirmButtonColor: '#032E58',
            cancelButtonColor: '#dc3545'
        }).then((result) => {
            console.log('retorno ', result);
            if (result.isConfirmed) {
                console.log('retorno 456 ', result);
                if (callback != null) {
                    console.log('retorno 789 ', result);
                    callback();
                }
            }
        });
    }

    showMessage(t: string, m: string, type: any = 'warning') {
        Swal.fire({
            title: t,
            html: m,
            icon: type,
            confirmButtonColor: '#032E58',
        });
    }
}
